// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/styles.scss
// module id = 1003
// module chunks = 0